import type {
    ActivationAlertsContractNewsVolumeDataPoint,
    ActivationAlertsContractNewsVolumeDomainData,
} from "@similarweb/pro-api-client";

import type { Series } from "../../common/widget/line-graph/types";
import { movePrimaryItemToStart } from "../../common/utils/movePrimaryItemToStart";
import type { NewsMetricsDataType } from "../types";

const getSeries = (dataPoints: ActivationAlertsContractNewsVolumeDataPoint[]) => {
    const result: Record<NewsMetricsDataType, Series> = {
        mentions: [],
        pressReleases: [],
        stories: [],
    };

    dataPoints.forEach(({ startDate, mentions, pressReleases, stories }) => {
        const x = startDate;

        result.mentions.push({
            x,
            y: mentions,
        });
        result.pressReleases.push({
            x,
            y: pressReleases,
        });
        result.stories.push({
            x,
            y: stories,
        });
    });

    return result;
};

type TransformVolumeOverTimeDataParams = {
    data: ActivationAlertsContractNewsVolumeDomainData[];
    primaryDomain?: string;
};

export const transformVolumeOverTimeData = ({ primaryDomain, data }: TransformVolumeOverTimeDataParams) => {
    const sortedData = primaryDomain ? movePrimaryItemToStart(primaryDomain, data) : data;

    return sortedData.map(({ dataPoints, domain, averageVolume }) => {
        const series = getSeries(dataPoints);

        return {
            domain,
            series,
            averageVolume,
        };
    });
};
